import { of } from 'rxjs';
import {
  catchError, map, mergeMap, filter,
} from 'rxjs/operators';
import { ajax } from 'rxjs/ajax';
import { signOutUser } from '../analytics/analytics-utils';
import {
  logoutAction,
  logoutSuccessAction,
  logoutFailureAction,
} from './logout-slice';
import { emptyAction } from '../shared/shared-actions';
import { determineDataUrls } from '../shared/utils/app-utils';

const logoutUserEpic = (action$) => action$.pipe(
  filter(logoutAction.match),
  mergeMap((action) => {
    const { fromAuth0 } = action.payload || {};
    return ajax({
      url: `${determineDataUrls().backendRoot}logout`,
      method: 'POST',
      withCredentials: true,
    }).pipe(
      map(() => {
        signOutUser();
        return logoutSuccessAction({ fromAuth0 });
      }),
      catchError((error) => of(logoutFailureAction(error))),
    );
  }),
);

const logoutUserSuccessEpic = (action$, state$) => action$.pipe(
  filter(logoutSuccessAction.match),
  mergeMap(() => {
    const { fromAuth0 } = state$.value.logout;
    if (!fromAuth0) {
      window.location.replace('/login');
    }
    return of(emptyAction());
  }),
);

export default [
  logoutUserEpic,
  logoutUserSuccessEpic,
];
